import Text from './Text';

import './styles/PrivacyPolicyText.css';

export default function PrivacyPolicyText() {
  return (
    <>
      <div className="privacy-policy-text__container">
        <Text className="privacy-policy-text__heading" large>
                    Introduction
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    Welcome to Suarte Tech S.L.U.'s Privacy Policy. We are committed to protecting and respecting your privacy. Suarte Tech S.L.U. 
                    ("Suarte" or "we" or "our" or "us") collects, stores, shares, and uses information when you use our web app, products, 
                    and services, as described in this Privacy Policy ("Policy").
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    By accessing or using our Services in any way, you agree that your information may be collected, stored, shared, and used as 
                    described in this Policy and our Terms and Conditions. You may withdraw consent at any time; however, such withdrawal does 
                    not negate our right to process your data prior to your withdrawal.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Applicability of this Privacy Policy
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    This Privacy Policy applies to all the services provided by Suarte, regardless of how you use them or whether or not you register for a 
                    Suarte account. It is important to note that this policy does not extend to third-parties we do not own or control, nor does it 
                    encompass individuals whom we do not employ or manage.
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    In the event that you are directed to a third-party website while using our services, you acknowledge and agree that the privacy 
                    policies of that third-party site will govern your interactions. However, we expect any third party with whom we share Personal 
                    Information to adhere to similar standards of privacy protection as outlined in this Policy.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Information we may collect from you
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    When you access or use our Services, we may collect various types of information that you provide or make available to us. This can include:
        </Text>

        <ol>
          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Information provided through forms: When you fill in forms on our Services, such as during the registration process for a Suarte 
                            account or when updating your account or user profile information, we may collect the information you provide, such as your name, 
                            email address, home address, and phone number.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Information from your use of our Services: When you access or use our Services, we may collect information about your interactions, 
                            the preferences you select, and how often you use specific features. This includes the information you provide on or through our Services, 
                            as well as details about how you access or use our Services. We may collect data on the artworks you browse, interact with, or view, 
                            as well as the artists, galleries, or other users you follow and interact with.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text margin" paragraph justify medium>
                            Information from direct communication: If you communicate with us directly through email, phone, postal mail, or other social media 
                            platforms, we may collect the information you provide during these interactions.
            </Text>
          </li>
        </ol>

        <Text className="privacy-policy-text__subheading" medium>
                    Information Collected Automatically
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    We may automatically collect certain information about how you access or use our Services. By using our Services, 
                    you consent to the collection of this information, which may include:
        </Text>

        <ul>
          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Internet browser, operating system, device, and application identifiers
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            IP address and geo-location information
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Access times and dates
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Referring and exit pages and URLs
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Clickstream data
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Search terms
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Pages viewed
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Time spent on pages
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Bounce rate
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text margin" paragraph justify medium>
                            Login frequency
            </Text>
          </li>
        </ul>

        <Text className="privacy-policy-text__subheading" medium>
                    Information from Cookies and similar technologies
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    We may collect information for marketing purposes through the use of cookies, web beacons, and similar technologies. 
                    These technologies help us operate, improve, and customize our Services, content, and marketing efficiency. 
                    They also assist us in understanding how users access and engage with our Services. Please note that some of 
                    our Services may require cookies to operate properly.
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Information from Other Users
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    If you use our Services to communicate or make a transaction with other users, we may obtain information or 
                    feedback from them about their interaction with you. Additionally, when users share user content that 
                    contains information about you, we will receive that information.
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Information from mobile use
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    When you access our Services on a mobile device, for example, when you download or use the Suarte web app or when 
                    you visit our website from a mobile browser, we may obtain information about your location and mobile device, 
                    including a unique identifier for your device. This information may be used to customize our Services, content, 
                    and marketing for your location. You can adjust your mobile device's location services settings as desired.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Why we collect information and how we use it
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    At Suarte, we value transparency and want to ensure that you have a clear understanding of why we collect information 
                    and how we use it. The information we collect is crucial for us to operate, improve, protect, and customize our Services, 
                    as well as develop new Services. It also helps us provide efficient customer support and enhance 
                    your overall experience on our platform.
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    We have outlined the legitimate business purposes for collecting information 
                    and the reasons behind it. Here are the various purposes and reasons 
                    for which we collect and use information:
        </Text>

        <ol>
          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Providing Services: We collect and use information to provide our Services to you, 
                            including any new Services we may develop in the future. 
                            This is essential for the performance of our contract with you and serves as a legitimate business purpose.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Customer Support: Your information enables us to offer effective customer support, 
                            ensuring that any issues or concerns you have are addressed promptly 
                            and efficiently. This is a legitimate business purpose.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Communications and Transactions: We use your information to facilitate communications 
                            or transactions between you and other Users, ensuring a seamless experience on 
                            our platform. This is done with your consent and serves as a legitimate business purpose.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Operating, Improving, and Customizing Services: Your information allows us to operate, 
                            improve, and customize our Services, Content, and marketing efforts. 
                            It helps us understand how you use and interact with our platform and 
                            enables us to develop new Services. This is a legitimate business purpose. 
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Personalized Content and Ads: We may use your information to provide more customized Content 
                            and ads, both on our Services and on external platforms. This is done with your 
                            consent and serves as a legitimate business purpose. 
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Security and Safety: Your information is vital to promoting and maintaining a trusted, safer, 
                            and more reliable environment on our platform. We use it to detect and prevent fraud, address 
                            security or technical issues, conduct investigations, and verify actions associated with your 
                            account. This is for the protection of the public interest and serves as a 
                            legitimate business purpose.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Account-related Communication: We may contact you through various channels to address 
                            account-related issues, collect fees, provide updates about our Services or policies, or 
                            for other purposes permitted by law. This is necessary for the performance of our contract 
                            with you and serves as a legitimate business purpose.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Marketing and Promotions: With your consent, we may contact you to send marketing communications, 
                            promotional messages, and offers about our Services, Content, and the products, services, and 
                            Content of others. You have the option to opt out of receiving certain communications. This 
                            is done with your consent and serves as a legitimate business purpose.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Contests and Promotional Events: We may use your information to facilitate your participation in 
                            rankings, and other promotions sponsored or conducted by us or in collaboration with others. 
                            This is necessary for the performance of our agreement with you.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Legal Compliance and Dispute Resolution: We may collect and use your information to comply with 
                            our legal obligations, resolve disputes, enforce our Terms and Conditions, or adhere to any other 
                            Suarte policies or agreements with Users. This is done to fulfill our legal obligations.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text margin" paragraph justify medium>
                            Other Purposes: We may use your information for other functions as described when the information 
                            is collected or requested, or for other purposes with your prior consent. 
                            This serves as a legitimate business purpose.
            </Text>
          </li>
        </ol>

        <Text className="privacy-policy-text__heading" large>
                    Communication Preferences
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    At Suarte, we understand the importance of allowing our users to have control over 
                    the communications they receive from us. We provide you with various options 
                    to manage your communication preferences:
        </Text>

        <ol>
          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Marketing Emails: If you no longer wish to receive marketing emails from us, you can easily unsubscribe by 
                            clicking the unsubscribe link provided in the email you received. We recommend adjusting your preferences 
                            in your profile and account settings if you have a registered Suarte account. Additionally, you can email 
                            us at privacy@suarte.com to express your communication preferences.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Account-related Communications: Some communications from us are essential for the proper 
                            functioning of your account and our Services. These include emails about your account or 
                            your transactions with us or other users. These communications are necessary 
                            and cannot be opted out of.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Contacting us: If you have any questions or concerns about your 
                            communication preferences or if you need further assistance, 
                            please don't hesitate to reach out to us at privacy@suarte.com. 
                            We are here to help.
            </Text>
          </li>
        </ol>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    Please note that if you choose to unsubscribe from receiving emails from us, 
                    you may miss out on important updates and announcements that could enhance 
                    your experience on our platform. 
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Accounts, Profiles, and Data Retention
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Accounts and Registration
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    At Suarte, creating an account is a simple and straightforward process. To register for a Suarte account, 
                    you will need to provide your full name and a valid email address. If you are registering as a business, 
                    additional information may be required. Once you have an account, you can access, manage, and update your 
                    profile and account settings as needed. It is your responsibility to ensure that the information in your 
                    account is accurate and up to date. When you make updates, we may retain a record of the previous 
                    information for purposes consistent with this Policy. Should you decide to cancel your account, 
                    you can do so using the tools provided, keeping in mind any applicable agreements and pending 
                    transactions. Please contact us at privacy@suarte.com for further assistance or information.
        </Text>
                
        <Text className="privacy-policy-text__subheading" medium>
                    Profile and Account Information
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    We believe in fostering an interactive community, and as such, certain profile and account 
                    information may be visible to other users on our platform to promote transparency and responsibility 
                    for content posted. However, users have control over making their artworks public. We encourage you 
                    to review and adjust these settings regularly to ensure they align with your preferences. 
                    If you have any questions or concerns, please don't hesitate to reach out to us at privacy@suarte.com.
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Data Retention
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    We retain your data in accordance with this Policy for as long as your account is active and as long 
                    as it is necessary to comply with any tax, legal, or regulatory requirements. Additionally, we may 
                    retain data to protect against potential legal claims. If you would like to request the deletion or 
                    return of your personally identifiable information, please contact us at privacy@suarte.com. It's 
                    important to note that deleting your data means you will no longer be able to access our services. 
                    However, we may retain anonymized, aggregated, and depersonalized data even after your information 
                    has been deleted from our platform.
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Follows, Likes, Thoughts, Ratings, and Other Features
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    Our platform offers various features that allow you to engage with artworks and other users in different ways. 
                    These features include that you can choose to follow artists, galleries, and other users whose content and 
                    updates you are interested in. By following them, you will receive updates and notifications about their activities. 
                    You also have the possibility to like, write thoughts, and rate artworks. The last two actions mentioned 
                    contribute to building your unique profile on the platform.
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    These features enhance your interaction with the platform and allow you to personalize your experience. 
                    You have the flexibility to modify your notification preferences from your profile, and in regards to emails, 
                    if you would like to opt out of receiving those emails, please follow the unsubscribe 
                    link at the bottom of the relevant email.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    User Contributions and Interactions
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    User Contributions
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    Suarte's platform presents a variety of features and services that allow you to provide user content. When you post or 
                    publish user content on our platform, understand that any information contained in your contributions, including any 
                    details within images or videos, becomes publicly accessible through our Services. This accessibility extends to 
                    indexing by and availability through third-party search engines. The access and use of this user content by Suarte 
                    and other users are defined in our Terms and Conditions. This applies regardless of whether this information is also 
                    provided to us by other means, in which case our use of such information might have been more limited under this Policy. 
                    Consequently, it is your responsibility to ensure you have the necessary rights to share any information about others 
                    that you share with us or other users through our Services.
        </Text>
                
        <Text className="privacy-policy-text__subheading" medium>
                    Connecting and sharing information with other users
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    Suarte's provides a dynamic platform and marketplace for users to discover and engage with a diverse range of artworks 
                    from Galleries worldwide. To facilitate these interactions, our services include features such as messaging options 
                    after making a purchase.
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    When you use our services to connect with another user or complete a transaction, we may share your name, email 
                    address, and other relevant contact information with them. This information helps facilitate communications, 
                    transactions, shipping processes, or marketing purposes. In some instances, users may gain access to additional 
                    information about you. For example, logistics companies have access to delivery addresses to ensure a 
                    successful shipment.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    How do we share personal information?
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    In this Policy, "Personal Information" denotes data that can independently be used to identify or get in touch with a 
                    specific individual, such as a name, email address, postal address, or phone number. Personal Information does not 
                    include data that, after being aggregated or anonymized, no longer identifies or could reasonably be used to contact 
                    a particular individual. In certain circumstances, Personal Information could also mean information you voluntarily 
                    provide to us, like users you decide to follow. We limit the sharing of your Personal Information to the methods 
                    outlined in this Policy or with your prior approval. Apart from the other instances of Personal Information sharing 
                    detailed in this Policy, your Personal Information might be shared under the following conditions.
        </Text>
                
        <Text className="privacy-policy-text__subheading" medium>
                    Third-Party Service providers
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    We may contract with third-party service providers that assist us in offering our Services or carry out related services on our behalf. 
                    These providers may need to process your Personal Information to fulfill these tasks. Examples include, but are not limited to, 
                    identity verification, document authentication, public database review, order fulfillment, package delivery, payment processing, 
                    bill collection, fraud investigation, email and postal mail administration, customer service assistance, web and mobile data 
                    analytics, advertising display, as well as server and database hosting services. To be clear, we do not sell your 
                    Personal Information to our Service Providers.
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Payment Processing
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    We utilize third parties, including Stripe, to gather your data from financial institutions. By using our Services, 
                    you authorize our third-party providers to act on your behalf to access and transmit your personal and financial 
                    information from the relevant financial institution, subject to the privacy policies and service terms of these 
                    third-party providers.
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Legal Obligations
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    We may access, preserve, and disclose your Personal Information and/or other data if we believe 
                    doing so is reasonably necessary to: 
        </Text>

        <ol>
          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Adhere to any law, regulation, legal procedure, or governmental request (including search warrants, 
                            subpoenas, or court orders), which may include responding to legal requests 
                            from jurisdictions outside Spain.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Implement our Terms and Conditions, other policies, or agreements with users, 
                            or investigate potential breaches
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Detect, address, or prevent fraud, security, or technical issues.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text" paragraph justify medium>
                            Protect or enforce the rights or property of Suarte, you, or any other individual or entity.
            </Text>
          </li>

          <li className="privacy-policy-text__list-item">
            <Text className="privacy-policy-text__text margin" paragraph justify medium>
                            Prevent physical harm to any person, including situations that could lead to violence or self-harm.
            </Text>
          </li>
        </ol>

        <Text className="privacy-policy-text__heading" large>
                    Non-personal and aggregated information
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    We may take any Personal Information that we have collected from or about you and anonymize and/or aggregate 
                    it so that it no longer contains any Personal Information. The anonymized or aggregated data can be utilized 
                    and shared for any legitimate business objectives, such as product development and marketing, and to provide 
                    insights to others regarding how our Services or content are being used and interacted with.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Payment Information
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    When you buy something from our marketplace or use certain Services, you'll need to provide payment details. 
                    This might be things like your credit card number, the type of card, and when it expires. We don't keep this 
                    credit card information ourselves. Instead, a third-party payment company stores it, and they have their own 
                    rules about how they use and keep this information. We do get some information from this payment company, 
                    including a unique code tied to you to approve your purchases and sometimes the last four numbers of your 
                    credit card. This is to help us stop any fraud or identity theft. If you don't want to give this payment 
                    information, there may be some Services on our platform you won't be able to use.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    External Websites and Services
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    Our platform may contain links to other websites or services that are not under our control, just as other websites 
                    or services not controlled by us may provide links to our platform. The platform provides features that enable you 
                    to share content on other websites and social media platforms. However, these links and features do not imply our 
                    endorsement of these external websites or services, or their privacy practices. When you interact with these other 
                    websites or services, they may gather information from you, including through cookies, web beacons, or similar
                    technologies. We strongly recommend reading the privacy policies of any other websites or services 
                    you engage with to understand their practices.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Global Data Handling
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    Suarte is based in Spain. Our users, which include Galleries that utilize our platform as sellers, Service providers, 
                    and other third parties you may interact with through our platform, may be located worldwide, including in countries 
                    that may not offer the same level of protection for Personal Information as in Spain. By accessing or using our 
                    platform in Spain or any other country, you consent to your information being transferred and processed in Spain 
                    and any other involved country.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Children's information
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    Our Services are not directed to children under the age of 16, and we do not knowingly collect Personal Information 
                    from people in this age group. If you believe we may have collected Personal Information f
                    rom anyone under the age of 16, please contact us at privacy@suarte.art.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Security
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    Every Suarte account is shielded by a password to preserve your privacy and ensuring security while using our services. 
                    If you choose to create an account, we strongly encourage the use of a robust password, featuring a unique combination 
                    of numbers, letters, and special characters. It's crucial to keep your password confidential at all times. In 
                    the event of any suspicious activity or confirmed unauthorized access to your account or password, you should 
                    notify us immediately at privacy@suarte.art and alter your password. Please bear in mind that while we strive 
                    to protect your information and secure our services, due to potential hardware or software malfunctions, 
                    unauthorized entries or usage, and other factors, we cannot guarantee absolute security of any information, 
                    be it online or offline. Any transmission of information occurs at your own discretion. Remember that any 
                    information submitted to us via email is not encrypted.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Legal Requests
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    Certain jurisdictions have laws that entitle individuals to access or rectify their Personal Information held by a company. 
                    We respect any statutory rights you may have to access or modify your Personal Information in our possession. You can send 
                    such requests to our dedicated email address, privacy@suarte.art. Upon receipt of your request, we will inform you if 
                    there are any administrative fees associated with fulfilling your request, as allowed by applicable law. However, note 
                    that even if you have a legal right to request access or rectification of your information, we may decline requests 
                    that are unduly repetitive, necessitate an unreasonably large technical effort (for example, creating a new system or 
                    significantly altering an existing practice), risk infringing on the privacy of others, or are impractical to comply 
                    with (for instance, requests to access information stored on backup systems), as allowed by applicable law.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Handling Disputes
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    This Privacy Policy is an integral part of our Terms and Conditions. Hence, 
                    any disagreements between you and us relating to privacy or usage of your data, 
                    stemming from or related to this Policy or our Services, fall under our Terms of Use. 
                    This includes any stipulations regarding restrictions on damages and liability, choice of law, 
                    and dispute resolution. If you feel your complaint hasn't been acknowledged promptly or 
                    addressed satisfactorily, users to lodge a complaint as per their respective country's 
                    data protection regulations.
        </Text>

        <Text className="privacy-policy-text__heading" large>
                    Updates to this Privacy Policy
        </Text>

        <Text className="privacy-policy-text__text margin" paragraph justify medium>
                    Our business evolves over time, and so does our Privacy Policy. We reserve the right to update this Policy, including our Cookie Policy, 
                    without prior notice and at our sole discretion. For instance, we may update this Policy to comply with legal changes or modifications
                    to our Services. All modifications to this Policy will be effective when they are posted on our Services or at a later specified 
                    date in the updated Policy. We will notify you of any modifications to this Policy by posting the revised Policy on our Services. 
                    We encourage you to regularly review this Policy and stay informed about any applicable modifications. By continuing to use our 
                    Services after any changes to this Policy are effective, you consent to these changes and the updated Policy. Unless stated 
                    otherwise, the latest version of this Policy will apply to all information we have about you or your account.
        </Text>

        <Text className="privacy-policy-text__subheading" medium>
                    Any doubts about Suarte's Privacy Policy? 
        </Text>

        <Text className="privacy-policy-text__text" paragraph justify medium>
                    If you have questions or comments about our Privacy Policy or practices related to privacy, or if you wish to find out, update, delete, 
                    or seek access to the Personal Information we have on you, please feel free to connect with us via email at privacy@suarte.art.
        </Text>
      </div>
    </>
  );
}
